export default __webpack_public_path__ + "static/media/icon_25.59387ebe.png";